import FrameSearch from '@screens/frame/search'

export default function FrameSearchPage() {
  return <FrameSearch />
}
